import { useState } from "react";
import { useSelector } from 'react-redux';
// utility
import { formatData } from '../../utility/functions';
// fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileVideo, faSpinner } from '@fortawesome/free-solid-svg-icons'

import MessaggioButtons from "./messaggio_buttons";

const MessaggioVideo = (props) => {
    const [ isHover, setIsHover ] = useState(false);
    const is_amministratore = useSelector((state) => state.dettaglio.is_amministratore);
    const msg = props.msg;

    return (
        <div 
            id={msg.ChiaveOrdinamento} 
            className={`w-100 d-flex py-2 msg_${msg.who}`}
            onMouseEnter={()=>{setIsHover(true)}}
            onMouseLeave={()=>{setIsHover(false)}}
        >
            <div className={`msg border shadow-sm rounded ${msg.active && 'active'} ${msg.eliminazione_in_corso === true && 'opacity-25'}`}>
                <div className="nome"><strong>{msg.who !== 'admin' && msg.who !== 'out' && msg.from_name}</strong></div>
                {msg.url === '' && (
                    <div className="file_wrapper px-4 pt-4 text-center">
                        <FontAwesomeIcon spin className="text-primary" size="lg" icon={faSpinner} />
                        {/* <p className="mt-2 mb-0">{msg.nome_originale}</p> */}
                    </div>

                )}
                {msg.url !== '' && (
                    <div className="file_wrapper px-3 pt-3 text-center">
                        <a target="_blank" donwload={msg.nome_originale} href={msg.url} rel="noreferrer">
                            <FontAwesomeIcon style={{ fontSize: 50 }} icon={faFileVideo} />
                            <p className="mt-2 mb-0 text-break">{msg.nome_originale}</p>
                        </a>
                    </div>
                )}
                <span className="data">{msg.who !== 'admin' ? formatData(msg.messaggio_data_ora) : ''}</span>
            </div>
            {isHover && is_amministratore && msg.who !== 'admin' && <MessaggioButtons msg={msg} setIsHover={setIsHover}/>}
        </div>
    )
}

export default MessaggioVideo